import {UserPreferenceType} from '../../constants/actionType';

const initialState = {
  favoriteLabwareIDs: [],
};

const actions = {
  [UserPreferenceType.SET_FAVORITE_LABWARE_IDS]: (state, action) => ({...state, favoriteLabwareIDs: action.data}),
};

export default function userPreferenceState(state = initialState, action = '') {
  const {type} = action;
  const func = actions[type];

  return func ? func(state, action) : state;
}
